<template>
  <el-table-column
    prop="tax_id_number"
    label="Adóazonosító jel"
    sortable="custom"
    min-width="180"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.tax_id_number || '-' }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'tax_id_number',
  };
</script>
